import React, { Component } from 'react';
import Constants from '../../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import toastr from 'toastr';

import Select from './select';
import TextBox from './textBox';

class ObjectDefinitionEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAddObject: {
        name: "",
        data_type: "",
        validation_dimension_id: ""
      }
    };
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  isValidObject = (object) => {
    let trimedName = object.name.trim();
    if(trimedName == "" || object.data_type == "" 
      || (object.data_type == Constants.selectKeys.metric.objectDefinitionDataType.DIMENSION && object.validation_dimension_id == "")) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(intl.formatMessage({ id: "metricAdmin.fields.object_definition_empty_error"}),"");
      return false;
    }
    else if(this.props.values && this.props.values.filter(item => (trimedName.toUpperCase() == item.name.toUpperCase())).length>0) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(intl.formatMessage({ id: "metricAdmin.fields.object_definition_duplicate_error"}),"");
      return false;
    }
    return true;
  };
  
  handleAddButtonClick = (event) => {
    if(this.editItemInput) {
      this.editItemInput.focus();
    }
  };

  handleCancelAdd = (event) => {
    this.setState({
      showOverlay: false,
      toAddObject: {
        name: "",
        data_type: "",
        validation_dimension_id: ""
      }
    });
  };

  handleChangeAddItem = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toAddObject = JavascriptUtilsTooling.deepCopy(this.state.toAddObject);
    if(event.currentTarget.dataset.path == "data_type") {
      toAddObject.validation_dimension_id = "";
    }
    toAddObject[event.currentTarget.dataset.path] = value;
    this.setState({
      showOverlay: true,
      toAddObject: toAddObject
    });    
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }  
  };

  handleSaveAddItem = (event) => {
    if(this.isValidObject(this.state.toAddObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toAddObject: {
          name: "",
          data_type: "",
          validation_dimension_id: ""
        }
      });
    }
  };

  render() {
    const {
      className,
      dataTypeOptions,
      validationDimensionsOptions,
      values,
      onChange,
      disabled,
      onlyEnabledAdd
    } = this.props;
    const dataPath = this.props["data-path"];
    return (
      <div className={"custom-input free-text-list select-list object-editor object-definition-editor" + (className ? " " + className : "") + " select-list-no-search" + (className ? " " + className : "") + " select-list-no-search" + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
        {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
        <div className="free-text-list-label">
          <FormattedMessage id="metricAdmin.fields.object_definition"/>
          {!disabled && (<i className="fas fa-plus-circle" onClick={this.handleAddButtonClick}/>)}
        </div>
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
                var dataType = item.data_type;
                var dataTypeName = dataTypeOptions ? dataTypeOptions.find(option => option.value == dataType) : null;
                var validationDimensionName = (dataType==Constants.selectKeys.metric.objectDefinitionDataType.DIMENSION && validationDimensionsOptions) ?
                   validationDimensionsOptions.find(dim => dim.value == item.validation_dimension_id) : "";
                dataType = dataTypeName ? dataTypeName.label : dataType;
                validationDimensionName = validationDimensionName ? ": " + validationDimensionName.label : "";                
              
                return (
                  <div key={i} className="free-text-list-list-item">
                    <div className="free-text-list-list-item-inner">
                      {item.name + " (" + dataType + validationDimensionName + ")"}
                    </div>
                    {(!disabled && (!onlyEnabledAdd || !item.id)) && (
                      <div className="free-text-list-list-item-action-buttons">
                        <i 
                          className="fas delete-action fa-trash"                          
                          data-index={i}
                          data-delete={"true"}
                          data-value={JSON.stringify(item)}
                          data-objecteditor={"true"}
                          data-path={dataPath}
                          onClick={onChange}
                        />
                      </div>
                    )}
                  </div>
                );           
            })}
            <div className="free-text-list-list-item free-text-list-list-item-add">
              <div className="free-text-list-list-item-inner">
                {!disabled && (
                  <div className="object-editor-inputs">
                    <Select 
                      className="free-text-list-list-add-item object-definition-editor-data-type-input"
                      value={this.state.toAddObject.data_type}
                      labelLocale={<FormattedMessage id="metricAdmin.fields.object_definition_data_type"/>}
                      options={dataTypeOptions ? dataTypeOptions : []}
                      onChange={this.handleChangeAddItem}
                      data-path={"data_type"}
                      ref={(input) => { this.editItemInput = input; }}
                    />
                    {this.state.toAddObject.data_type==Constants.selectKeys.metric.objectDefinitionDataType.DIMENSION && (
                      <Select 
                        data-path="validation_dimension_id"
                        value={this.state.toAddObject.validation_dimension_id}
                        onChange={this.handleChangeAddItem}
                        labelLocale={<FormattedMessage id="metricAdmin.fields.object_definition_validation_dimension"/>}
                        options={validationDimensionsOptions ? validationDimensionsOptions : []}
                        className="free-text-list-list-add-item object-definition-editor-validation-dimension-input"
                      />
                    )}
                    <TextBox
                      className="free-text-list-list-edit-item object-definition-editor-name-input"
                      styleType={Constants.interface.inputs.styleType.OUTLINED}
                      onChange={this.handleChangeAddItem}
                      data-path={"name"}
                      value={this.state.toAddObject.name}
                      onKeyEsc={this.handleCancelAdd}
                      onKeyEnter={this.handleOnEnterAddItem}
                      type={Constants.interface.inputs.type.TEXT}
                      labelLocale={<FormattedMessage id="metricAdmin.fields.object_definition_name"/>}
                    />
                  </div>
                )}
              </div>
              {!disabled && (
                <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-add">
                  <i 
                    ref={(input) => { this.addItemSaveButton = input; }}
                    className="fas fa-save"
                    data-objecteditor={"true"}
                    data-value={JSON.stringify(this.state.toAddObject)}
                    data-path={dataPath}
                    onClick={this.handleSaveAddItem}   
                  />
                  <i 
                    className="fas cancel-action fa-times-circle"
                    onClick={this.handleCancelAdd}
                  />
                </div>
              )}
            </div>
          </div>
      </div>
    );
  }
}

export default ObjectDefinitionEditor;



// WEBPACK FOOTER //
// ./source/client/components/common/inputs/objectDefinitionEditor.jsx